import React, { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';

import discountTag from '../../../assets/landing/discount-tag.svg';

import './DiscountApplied.css';
import { useWADiscountLabel } from '../../../hooks';

const DiscountTagItem = ({ item }) => (
  <div className="Row Discount-applied-item">
    <img
      alt=""
      className="Discount-tag-icon"
      src={discountTag}
    />

    <span>{item.Percentage} {item.Description}</span>
  </div>
);

const DiscountApplied = ({ isSecondStep = false }) => {
  const { t } = useTranslation('quoting');
  const showWADiscount = useWADiscountLabel();
  const classNameContainer = `Discount-applied-container${isSecondStep
    ? '-your-info' : ''}`;
  const store = useSelector(({ quoting }) => quoting, shallowEqual);
  const { rateSummary } = store;

  const validDiscounts = useMemo(() => {
    let filteredDiscounts = rateSummary.AllDiscounts.filter(
      (discount) => discount.Description || discount.Percentage,
    );
    if (showWADiscount) {
      filteredDiscounts = filteredDiscounts.map((discount) => ({
        ...discount,
        Description: `${discount.Description} ${t('appliedWA')}`,
      }));
    }
    return filteredDiscounts;
  }, [rateSummary.AllDiscounts, showWADiscount, t]);

  if (validDiscounts.length === 0) {
    return null;
  }

  return (
    <div className={classNameContainer}>
      <h1 className={'Text-title Discount-applied-title'
        + ' Text-center'}
      >
        {showWADiscount
          ? t('discountWA')
          : t('discount', { count: validDiscounts.length })}
      </h1>

      <div className="Row Discount-applied-items">
        {validDiscounts.map((item, index) => (
          <DiscountTagItem
            key={item.Description.replace(/\s/, '')}
            index={index}
            item={item}
          />
        ))}
      </div>

      {showWADiscount && (
        <p className="Discount-applied-wa">{t('discountVet')}</p>
      )}
    </div>
  );
};

export default DiscountApplied;
